/**
 * EntrepreneurSubPage — Batch #14.313 : redirection des anciens liens /admin/entrepreneurs/:masterId/:tileId
 * vers la tuile équivalente du hub Tenue de livres (/admin/tenue-livres/:masterId/:tileId).
 */
import { Navigate, useParams } from "react-router-dom";

export default function EntrepreneurSubPage() {
  const { masterId, tileId } = useParams();
  return <Navigate to={`/admin/tenue-livres/${masterId}/${tileId}`} replace />;
}
